module.exports = __webpack_public_path__ + "static/media/boomBassador-icon-white.f98a7cdb.png";